import { modals } from "@mantine/modals"
import { notifications } from "@mantine/notifications"
import { useTranslation } from "react-i18next"
import { useAPIResource } from "@/hooks"
import { sessionsAPI } from "@/utils"
import type { TScheduleProps } from "../types"

export function useSaveSession({ activityId, session }: TScheduleProps) {
  const { t } = useTranslation()
  const api = useAPIResource(sessionsAPI, { id: session?.id })

  return ({ defaultInvite, note, ...values }) => {
    modals.closeAll()

    if (!defaultInvite) values = { ...values, note }

    if (session?.id) {
      api.update({ ...values, id: session.id, meta: { ...session.meta, ...values.meta } })
    } else {
      api.create({ ...values, activity_id: activityId })
    }
    notifications.show({ message: t("Activity scheduled") })
  }
}
